import { render, staticRenderFns } from "./ParentView.vue?vue&type=template&id=1fcc4976"
import script from "./ParentView.vue?vue&type=script&lang=js"
export * from "./ParentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcc4976')) {
      api.createRecord('1fcc4976', component.options)
    } else {
      api.reload('1fcc4976', component.options)
    }
    module.hot.accept("./ParentView.vue?vue&type=template&id=1fcc4976", function () {
      api.rerender('1fcc4976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/ParentView.vue"
export default component.exports